import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/tesouraria',
    name: 'treasury',
    redirect: '/tesouraria/contas_a_pagar',
    meta: {
      permission: ['gestor', 'financeiro'],
      listCanShow: [
        FEATURES.TREASURY,
        FEATURES.FATURAMENTO,
        FEATURES.TESOURARIA_FORMULARIO_REEMBOLSO,
      ],
      search: {
        title: 'Tesouraria',
        description: 'Contas a pagar, faturamento e reembolsos',
        keywords: [
          'tesouraria',
          'contas a pagar',
          'faturamento',
          'reembolso',
          'financeiro',
        ],
        icon: 'mdi-hand-coin',
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () =>
      lazyLoadView(
        import(
          '@src/modules/tesouraria/views/view-treasury-nav-bar/view-treasury-nav-bar.vue'
        )
      ),
    children: [
      {
        path: 'contas_a_pagar',
        name: 'treasury.contas_a_pagar',
        meta: {
          can_show: FEATURES.TREASURY,
          permission: ['gestor', 'financeiro'],
          search: {
            title: 'Tesouraria — Contas a pagar',
            description: 'Gestão de contas a pagar',
            keywords: [
              'contas a pagar',
              'pagamentos',
              'despesas',
              'tesouraria',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@src/modules/tesouraria/views/view-bills-to-pay/view-bills-to-pay.vue'
            )
          ),
      },
      {
        path: 'contas_a_receber',
        name: 'treasury.contas_a_receber',
        meta: {
          can_show: FEATURES.FATURAMENTO,
          permission: ['gestor', 'financeiro'],
          search: {
            title: 'Tesouraria — Faturamento',
            description: 'Faturamento e contas a receber',
            keywords: [
              'faturamento',
              'contas a receber',
              'receita',
              'tesouraria',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@src/modules/tesouraria/views/view-bills-to-receive/view-bills-to-receive.vue'
            )
          ),
      },
      {
        path: 'solicitacoes',
        name: 'treasury.solicitations',
        meta: {
          can_show: FEATURES.TESOURARIA_FORMULARIO_REEMBOLSO,
          search: {
            title: 'Tesouraria — Solicitações',
            description: 'Solicitações de reembolso',
            keywords: ['solicitações', 'reembolso', 'formulário', 'tesouraria'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@src/modules/tesouraria/views/view-solicitations/view-solicitations.vue'
            )
          ),
      },
    ],
  },
]
